import { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import api from '../config/axios';
import { useLanguage } from '../context/LanguageContext';
import { BASE_URL } from '../config/environment';
import { 
  MdArrowBack, 
  MdCheckCircle, 
  MdPending, 
  MdCancel, 
  MdUpload, 
  MdDownload, 
  MdDelete,
  MdChevronRight,
  MdClose,
  MdEdit,
  MdPersonAdd,
  MdAssignment,
  MdUpdate,
  MdPriorityHigh,
  MdAddTask,
  MdExpandMore,
  MdSmartToy,
  MdRefresh
} from 'react-icons/md';
import { CiMenuKebab } from "react-icons/ci";

// File URL helper fonksiyonu
const getFileUrl = (filePath) => {
  if (!filePath) return null;
  // Eğer filePath zaten tam URL ise (http ile başlıyorsa) direkt döndür
  if (filePath.startsWith('http')) {
    return filePath;
  }
  // Eğer relative path ise BASE_URL ile birleştir
  return `${BASE_URL}${filePath}`;
};

const SupportCaseDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  
  // Timezone düzeltme fonksiyonu - tüm tarih alanları için kullanılacak
  const adjustForTimezone = (dateTimeString) => {
    if (!dateTimeString) return dateTimeString;
    // Tarih string'ini parse et
    const [datePart, timePart] = dateTimeString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes] = timePart.split(':');
    
    // Saate 3 ekle (Türkiye UTC+3)
    let adjustedHours = parseInt(hours) + 3;
    let adjustedDay = parseInt(day);
    let adjustedMonth = parseInt(month);
    let adjustedYear = parseInt(year);
    
    // Gün sonu kontrolü
    if (adjustedHours >= 24) {
      adjustedHours -= 24;
      adjustedDay += 1;
      
      // Ay sonu kontrolü
      const daysInMonth = new Date(adjustedYear, adjustedMonth, 0).getDate();
      if (adjustedDay > daysInMonth) {
        adjustedDay = 1;
        adjustedMonth += 1;
        
        // Yıl sonu kontrolü
        if (adjustedMonth > 12) {
          adjustedMonth = 1;
          adjustedYear += 1;
        }
      }
    }
    
    // Formatı düzelt
    const formattedMonth = adjustedMonth.toString().padStart(2, '0');
    const formattedDay = adjustedDay.toString().padStart(2, '0');
    const formattedHours = adjustedHours.toString().padStart(2, '0');
    
    return `${adjustedYear}-${formattedMonth}-${formattedDay}T${formattedHours}:${minutes}`;
  };
  const [caseData, setCaseData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [fileDescription, setFileDescription] = useState('');
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState('');
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showOwnerPopup, setShowOwnerPopup] = useState(false);
  const [showAssignPopup, setShowAssignPopup] = useState(false);
  const [showStatusPopup, setShowStatusPopup] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [isUpdatingOwner, setIsUpdatingOwner] = useState(false);
  const [severityOptions, setSeverityOptions] = useState([]);
  const [showSeverityPopup, setShowSeverityPopup] = useState(false);
  const [selectedSeverity, setSelectedSeverity] = useState('');
  const [severityDescription, setSeverityDescription] = useState('');
  const [isUpdatingSeverity, setIsUpdatingSeverity] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    title: '',
    message: '',
    type: 'success',
    showCancel: false,
    onConfirm: null
  });
  
  // Activities state
  const [activities, setActivities] = useState([]);
  const [isLoadingActivities, setIsLoadingActivities] = useState(false);
  const [showActivityPopup, setShowActivityPopup] = useState(false);
  const [activityData, setActivityData] = useState({
    activity_start_date: '',
    activity_end_date: '',
    activity_type: '',
    activity_message: ''
  });
  const [isSubmittingActivity, setIsSubmittingActivity] = useState(false);
  const [showResolvePopup, setShowResolvePopup] = useState(false);
  const [selectedActivityForResolve, setSelectedActivityForResolve] = useState(null);
  const [isResolving, setIsResolving] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showRemoveMarkPopup, setShowRemoveMarkPopup] = useState(false);
  const [selectedActivityForRemove, setSelectedActivityForRemove] = useState(null);
  const [showStatusSuccessPopup, setShowStatusSuccessPopup] = useState(false);
  const [showSlaModal, setShowSlaModal] = useState(false);
  const [slaStatistics, setSlaStatistics] = useState(null);
  const [isLoadingSlaStats, setIsLoadingSlaStats] = useState(false);
  const [showActionsMenu, setShowActionsMenu] = useState(false);
  
  // AI öneri popup ve durumları
  const [showAiPopup, setShowAiPopup] = useState(false);
  const [isGeneratingAi, setIsGeneratingAi] = useState(false);
  const [aiSuggestion, setAiSuggestion] = useState('');


  
  const fileInputRef = useRef(null);
  
  const [isFilesTableExpanded, setIsFilesTableExpanded] = useState(false);
  const [isActivitiesTableExpanded, setIsActivitiesTableExpanded] = useState(false);
  const [isUploadSectionExpanded, setIsUploadSectionExpanded] = useState(false);
  
  // Gemini AI'dan öneri üretme fonksiyonu (Subject + Detail ile)
  const generateAiSuggestion = async () => {
    // Eğer veri yoksa kullanıcıyı bilgilendir
    if (!caseData) return;
    const subject = caseData.subject || '';
    const detail = caseData.detail || '';

    // Boşsa temel bir istek metni döndür
    if (!subject.trim() && !detail.trim()) {
      setAiSuggestion('Merhabalar, yaşadığınız sorunla ilgili daha fazla bilgi paylaşabilir misiniz? Hatanın tam olarak nerede ve nasıl oluştuğunu, ekran görüntüsü veya hata günlüğünü iletebilir misiniz?');
      return;
    }

    try {
      setIsGeneratingAi(true);
      setAiSuggestion('');

      // API anahtarını localStorage'dan oku veya otomatik kaydet
      let GEMINI_API_KEY = localStorage.getItem('GEMINI_API_KEY');
      
      if (!GEMINI_API_KEY) {
        // API anahtarını otomatik kaydet
        GEMINI_API_KEY = 'AIzaSyAaHX9SidJ8nUdNLty8lcAXGnhDuRQ3KTQ';
        localStorage.setItem('GEMINI_API_KEY', GEMINI_API_KEY);
      }

      // Prompt'u kısa ve öz yanıt için hazırla
      const prompt = `Destek kaydı analizi:\n\nSubject: ${subject}\nDetail: ${detail}\n\nBu durum için müşteriye gönderilecek KISA ve ÖZ bir yanıt taslağı yaz. Maksimum 3-4 cümle. Türkçe yaz. Ayrıca daha detaylı inceleme için log dosyaları, hata mesajları veya ekran görüntüleri iste.`;

      const res = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${GEMINI_API_KEY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          contents: [
            {
              parts: [{ text: prompt }]
            }
          ]
        })
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`AI isteği başarısız: ${res.status} - ${errorText}`);
      }
      
      const data = await res.json();
      const text = data?.candidates?.[0]?.content?.parts?.[0]?.text || '';
      setAiSuggestion(text || 'Merhabalar, paylaştığınız bilgiler için teşekkürler. Detaylı analiz için hata mesajı, olay zamanı, son yapılan değişiklikler ve mümkünse log kayıtlarını paylaşabilir misiniz?');
    } catch (err) {
      // Hata halinde anlamlı bir mesaj göster
      setAiSuggestion('Merhabalar, paylaştığınız bilgiler için teşekkürler. Daha hızlı yardımcı olabilmemiz için hata mesajı, ilgili loglar, son yapılan değişiklikler ve sorunun tekrarlandığı adımlar gibi detayları paylaşabilir misiniz?');
    } finally {
      setIsGeneratingAi(false);
    }
  };

  // AI önerisini Aktivite formuna aktarma
  const addAiToActivity = () => {
    // Şu anki tarih ve saati ayarla (Türkiye saati UTC+3)
    const now = new Date();
    // UTC+3 offset ekle
    const turkeyTime = new Date(now.getTime() + (3 * 60 * 60 * 1000));
    const formattedDateTime = turkeyTime.toISOString().slice(0, 16); // Format: YYYY-MM-DDTHH:MM
    
    // Aktivite popup'ını aç ve mesaj alanını AI metni ile doldur
    setActivityData({
      activity_start_date: formattedDateTime,
      activity_end_date: formattedDateTime,
      activity_type: '',
      activity_message: aiSuggestion || ''
    });
    setShowAiPopup(false);
    setShowActivityPopup(true);
  };
  
  useEffect(() => {
    fetchCaseData();
    fetchCaseFiles();
    fetchAgents();
  }, [id]);
  
  // Add a new useEffect to fetch severity options when caseData is loaded
  useEffect(() => {
    if (caseData && caseData.product_id) {
      fetchSeverityOptions();
    }
  }, [caseData]);

  // Close actions menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showActionsMenu && !event.target.closest('.relative')) {
        setShowActionsMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showActionsMenu]);
  
  // Add a new useEffect to fetch activities when caseData is loaded
  useEffect(() => {
    if (caseData && caseData.id) {
      fetchActivities();
    }
  }, [caseData]);

  // SLA İstatistikleri fonksiyonu
  const handleShowSlaStatistics = async () => {
    try {
      setIsLoadingSlaStats(true);
      setShowSlaModal(true);
      
      const response = await api.get(`/support-cases/${id}/sla-statistics`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      setSlaStatistics(response.data);
    } catch (error) {
      console.error(t('supportCase.slaStatsLoadError'), error);
      setPopup({
        show: true,
        title: t('supportCase.error'),
        message: t('supportCase.slaStatsLoadError'),
        type: 'error',
        showCancel: false,
        onConfirm: () => setPopup({ ...popup, show: false })
      });
    } finally {
      setIsLoadingSlaStats(false);
    }
  };
  

  
  const fetchCaseData = async () => {
    try {
      const response = await api.get(`/support-cases/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setCaseData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching case data:', error);
      setIsLoading(false);
    }
  };
  
  const fetchCaseFiles = async () => {
    try {
      const response = await api.get(`/support-case-files/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      // Ensure files is always an array
      setFiles(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error fetching case files:', error);
      // Set files to empty array on error
      setFiles([]);
    }
  };
  
  const fetchAgents = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error(t('supportCase.tokenNotFound'));
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      const response = await api.get('/agents', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      setAgents(response.data);
    } catch (error) {
      console.error('Error fetching agents:', error);
      
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.agentsLoadError', { error: error.response?.data?.message || error.message }),
        type: 'error'
      });
    }
  };
  
  const fetchActivities = async () => {
    setIsLoadingActivities(true);
    try {
      const response = await api.get(`/support-case-activities/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setActivities(response.data);
    } catch (error) {
      console.error('Error fetching case activities:', error);
    } finally {
      setIsLoadingActivities(false);
    }
  };
  

  
  const handleDeleteCase = () => {
    showPopup({
      title: t('supportCase.confirmation'),
      message: t('supportCase.deleteCaseConfirm'),
      type: 'warning',
      showCancel: true,
      onConfirm: async () => {
        try {
          // Önce token'ı kontrol et
          const token = localStorage.getItem('token');
          if (!token) {
            console.error(t('supportCase.tokenNotFound'));
            // Kullanıcıyı login sayfasına yönlendir
            navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
            return;
          }
          
          try {
            await api.delete(`/support-cases/${id}`, {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });
            
            showPopup({
              title: t('supportCase.success'),
              message: t('supportCase.caseDeletedSuccess'),
              type: 'success',
              onConfirm: () => navigate('/support-cases')
            });
          } catch (error) {
            console.error('Error deleting support case:', error);
            
            // 403 hatası alındıysa token süresi dolmuş olabilir
            if (error.response && error.response.status === 403) {
              // Kullanıcıyı login sayfasına yönlendir
              localStorage.removeItem('token'); // {t('tokenCleared')}
              navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
              return;
            }
            
            // 404 hatası alındıysa destek talebi bulunamadı
            if (error.response && error.response.status === 404) {
              showPopup({
                title: t('supportCase.error'),
                message: t('supportCase.caseNotFound'),
                type: 'error',
                onConfirm: () => window.location.reload()
              });
              return;
            }
            
            showPopup({
              title: t('supportCase.error'),
                message: t('supportCase.caseDeleteError', { error: error.response?.data?.message || error.message || 'Bilinmeyen bir hata' }),
              type: 'error'
            });
          }
        } catch (error) {
          console.error('Beklenmeyen hata:', error);
          showPopup({
            title: t('supportCase.error'),
            message: t('supportCase.unexpectedError'),
            type: 'error'
          });
        }
      }
    });
  };
  
  const handleFileUpload = async (uploadedFiles) => {
    if (!uploadedFiles || uploadedFiles.length === 0) return;
    
    setIsUploading(true);
    const formData = new FormData();
    
    // Append each file to the form data
    for (let i = 0; i < uploadedFiles.length; i++) {
      formData.append('files', uploadedFiles[i]);
    }
    
    // Add support case ID and description
    formData.append('support_case_id', id);
    formData.append('file_description', fileDescription || t('supportCase.noFileDescription'));
    
    // Get user info from localStorage
    const userInfo = JSON.parse(localStorage.getItem('user'));
    formData.append('uploaded_by', userInfo?.id || 'unknown');
    formData.append('uploaded_by_name', userInfo?.full_name || userInfo?.username || 'Bilinmiyor');
    
    try {
      // Önce token'ı kontrol et
      const token = localStorage.getItem('token');
      if (!token) {
        console.error(t('supportCase.tokenNotFound'));
        // Kullanıcıyı login sayfasına yönlendir
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      try {
        const response = await api.post('/upload-case-files', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.data.success) {
          showPopup({
            title: t('supportCase.success'),
            message: t('supportCase.filesUploadedSuccess'),
            type: 'success'
          });
          
          // Reset file description
          setFileDescription('');
          
          // Refresh the file list
          fetchCaseFiles();
        } else {
          throw new Error(response.data.message || t('supportCase.fileUploadFailed'));
        }
      } catch (error) {
        console.error('Error uploading files:', error);
        
        // 403 hatası alındıysa token süresi dolmuş olabilir
        if (error.response && error.response.status === 403) {
          // Kullanıcıyı login sayfasına yönlendir
          localStorage.removeItem('token'); // {t('tokenCleared')}
          navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
          return;
        }
        
        showPopup({
          title: t('supportCase.error'),
          message: t('supportCase.fileUploadError', { error: error.response?.data?.message || error.message }),
          type: 'error'
        });
      }
    } catch (error) {
      console.error('Beklenmeyen hata:', error);
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.unexpectedError'),
        type: 'error'
      });
    } finally {
      setIsUploading(false);
      // Clear file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };
  
  const handleDownloadFile = async (fileId, originalFileName) => {
    try {
      // {t('fileIdAndNameLogging')}
      
      // Önce token'ı kontrol et
      const token = localStorage.getItem('token');
      if (!token) {
        console.error(t('supportCase.tokenNotFound'));
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      // Dosya adı için dosya listesinden kontrol
      const fileInfo = files.find(f => f.id === fileId);
      let fileName = 'dosya';
      
      if (fileInfo) {
        // Olası dosya adı alanlarını kontrol et
        fileName = fileInfo.original_name || fileInfo.file_name || 
                  fileInfo.filename || fileInfo.name || originalFileName || `dosya_${fileId}`;
      } else if (originalFileName) {
        fileName = originalFileName;
      } else {
        fileName = `dosya_${fileId}`;
      }
      
      // URL parametre olarak dosya adını geçir
      const url = getFileUrl(`/download-case-file/${fileId}?filename=${encodeURIComponent(fileName)}`);
      
      // Doğrudan indirme isteği yapma
      const response = await api.get(url, {
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      
      // Content-Type headerını alma
      const contentType = response.headers['content-type'] || 'application/octet-stream';
      
      // Dosya adını Content-Disposition headerından almaya çalış
      const contentDisposition = response.headers['content-disposition'];
      let downloadFileName = fileName;
      
      if (contentDisposition) {
        // Regex ile filename parametresini çıkar
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch.length > 1) {
          const extractedName = filenameMatch[1].replace(/['"]/g, '').trim();
          if (extractedName && extractedName !== 'undefined') {
            downloadFileName = extractedName;
          }
        }
      }
      
      // {t('extensionCheck')}
      if (!downloadFileName.includes('.') && fileName.includes('.')) {
        const extension = fileName.split('.').pop();
        if (extension) {
          downloadFileName += '.' + extension;
        }
      } 
      // Uzantı hala yoksa content type'tan tahmin et
      else if (!downloadFileName.includes('.')) {
        // {t('extensionFromContentType')}
        const extension = contentType.split('/')[1];
        if (extension && extension !== 'octet-stream') {
          downloadFileName += '.' + extension;
        } else {
          // Genel dosya tiplerini kontrol et
          if (contentType === 'application/pdf') {
            downloadFileName += '.pdf';
          } else if (contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            downloadFileName += '.docx';
          } else if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            downloadFileName += '.xlsx';
          } else if (contentType === 'image/jpeg') {
            downloadFileName += '.jpg';
          } else if (contentType === 'image/png') {
            downloadFileName += '.png';
          } else if (contentType === 'text/plain') {
            downloadFileName += '.txt';
          } else if (contentType === 'application/zip') {
            downloadFileName += '.zip';
          }
        }
      }
      
      
      // Create a URL for the blob with correct content type
      const blob = new Blob([response.data], { type: contentType });
      const url_blob = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url_blob;
      link.setAttribute('download', downloadFileName);
      document.body.appendChild(link);
      link.click();
      
      // Temizlik
      setTimeout(() => {
        window.URL.revokeObjectURL(url_blob);
        link.remove();
      }, 100);
      
    } catch (error) {
      console.error('Error downloading file:', error);
      
      // 403 hatası alındıysa token süresi dolmuş olabilir
      if (error.response && error.response.status === 403) {
        // Kullanıcıyı login sayfasına yönlendir
        localStorage.removeItem('token'); // {t('tokenCleared')}
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.fileDownloadError', { error: error.response?.data?.message || error.message || 'Bilinmeyen bir hata' }),
        type: 'error'
      });
    }
  };
  
  const handleDeleteFile = async (fileId) => {
    showPopup({
      title: t('supportCase.confirmation'),
      message: t('supportCase.deleteFileConfirm'),
      type: 'warning',
      showCancel: true,
      onConfirm: async () => {
        try {
          // Önce token'ı kontrol et
          const token = localStorage.getItem('token');
          if (!token) {
            console.error(t('supportCase.tokenNotFound'));
            // Kullanıcıyı login sayfasına yönlendir
            navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
            return;
          }
          
          try {
            await api.delete(`/delete-case-file/${fileId}`, {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });
            
            showPopup({
              title: t('supportCase.success'),
              message: t('supportCase.fileDeletedSuccess'),
              type: 'success'
            });
            
            // Refresh the file list
            fetchCaseFiles();
          } catch (error) {
            console.error('Error deleting file:', error);
            
            // 403 hatası alındıysa token süresi dolmuş olabilir
            if (error.response && error.response.status === 403) {
              // Kullanıcıyı login sayfasına yönlendir
              localStorage.removeItem('token'); // {t('tokenCleared')}
              navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
              return;
            }
            
            showPopup({
              title: t('supportCase.error'),
              message: t('supportCase.fileDeleteError', { error: error.response?.data?.message || error.message || 'Bilinmeyen bir hata' }),
              type: 'error'
            });
          }
        } catch (error) {
          console.error('Beklenmeyen hata:', error);
          showPopup({
            title: t('supportCase.error'),
            message: t('supportCase.unexpectedError'),
            type: 'error'
          });
        }
      }
    });
  };
  
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };
  
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFileUpload(e.dataTransfer.files);
    }
  };
  
  const handleFileInputChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      handleFileUpload(e.target.files);
    }
  };
  
  const openFileSelector = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  
  const getStatusIcon = (status) => {
    switch (status) {
      case 'OPEN':
        return <MdPending className="text-yellow-500" size={20} />;
      case 'IN PROGRESS':
        return <MdCheckCircle className="text-blue-500" size={20} />;
      case 'CLOSED':
        return <MdCancel className="text-gray-500 dark:text-gray-400" size={20} />;
      default:
        return <MdPending className="text-yellow-500" size={20} />;
    }
  };
  
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('tr-TR');
  };
  
  // Çalışma günlerini formatlayan fonksiyon
  const formatWorkDays = (workDaysString) => {
    if (!workDaysString) return t('supportCase.notSpecifiedShort');
    
    const dayMap = {
      'monday': 'Pazartesi',
      'tuesday': t('supportCase.tuesday'),
      'wednesday': t('supportCase.wednesday'),
      'thursday': t('supportCase.thursday'),
      'friday': 'Cuma',
      'saturday': 'Cumartesi',
      'sunday': 'Pazar'
    };
    
    return workDaysString.split(',').map(day => dayMap[day.trim().toLowerCase()] || day.trim()).join(', ');
  };
  

  
  // Popup management
  const showPopup = (options) => {
    setPopup({
      show: true,
      title: options.title || 'Bildirim',
      message: options.message,
      type: options.type || 'success',
      showCancel: options.showCancel ?? false,
      onConfirm: options.onConfirm || null
    });
  };
  
  const closePopup = () => {
    setPopup(prev => ({ ...prev, show: false }));
  };
  
  const confirmPopup = () => {
    if (popup.onConfirm) {
      popup.onConfirm();
    }
    closePopup();
  };
  
  const handleTakeOwnership = () => {
    // Default mesajı ayarla
    const userInfo = JSON.parse(localStorage.getItem('user'));
    const defaultMessage = `Merhabalar, oluşturmuş olduğunuz destek talebi ile ilgili sizlere ben yardımcı olacağım. Case ile ilgili detayları inceleyip en kısa zamanda dönüş sağlayacağım.\n\n[${userInfo?.fullName || 'Agent'}]`;
    
    setNotificationMessage(defaultMessage);
    setShowOwnerPopup(true);
  };
  
  const handleAssignCase = () => {
    // Default mesajı ayarla
    const defaultMessage = `Merhabalar, oluşturmuş olduğunuz destek talebi ile ilgili sizlere ben yardımcı olacağım. Case ile ilgili detayları inceleyip en kısa zamanda dönüş sağlayacağım.\n\n[Agent Name]`;
    
    setNotificationMessage(defaultMessage);
    setShowAssignPopup(true);
  };
  
  const updateCaseOwner = async (ownerId) => {
    setIsUpdatingOwner(true);
    
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error(t('supportCase.tokenNotFound'));
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      const response = await api.put(`/update-case-owner/${id}`, {
        case_owner: ownerId,
        notification_message: notificationMessage
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.data.success) {
        showPopup({
          title: t('supportCase.success'),
          message: t('supportCase.caseAssignedSuccess'),
          type: 'success',
          onConfirm: () => {
            // Refresh case data
            fetchCaseData();
          }
        });
      } else {
        throw new Error(response.data.message || t('supportCase.assignmentFailed'));
      }
    } catch (error) {
      console.error('Error updating case owner:', error);
      
      if (error.response && error.response.status === 403) {
        localStorage.removeItem('token');
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.caseAssignError', { error: error.response?.data?.message || error.message }),
        type: 'error'
      });
    } finally {
      setIsUpdatingOwner(false);
      setShowOwnerPopup(false);
      setShowAssignPopup(false);
    }
  };
  
  const confirmTakeOwnership = () => {
    const userInfo = JSON.parse(localStorage.getItem('user'));
    if (!userInfo || !userInfo.id) {
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.userInfoNotFound'),
        type: 'error'
      });
      return;
    }
    
    updateCaseOwner(userInfo.id);
  };
  
  const confirmAssignCase = () => {
    if (!selectedAgent) {
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.selectAgentRequired'),
        type: 'error'
      });
      return;
    }
    
    updateCaseOwner(selectedAgent);
  };
  
  const handleChangeStatus = () => {
    // Set the current status as the default selected status
    setSelectedStatus(caseData.case_status);
    setShowStatusPopup(true);
  };
  
  const handleChangeSeverity = () => {
    // Fetch severity options if not already loaded
    if (severityOptions.length === 0) {
      fetchSeverityOptions();
    }
    
    // Set the current severity as the default selected severity
    setSelectedSeverity(caseData.sla_definition_id || '');
    setSeverityDescription('');
    setShowSeverityPopup(true);
  };
  
  const confirmStatusChange = async () => {
    if (!selectedStatus) {
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.selectStatusRequired'),
        type: 'error'
      });
      return;
    }
    
    // CLOSED durumundaki çağrıyı IN PROGRESS yapmaya çalışıyorsa ve resolved aktivite varsa uyarı ver
    if (caseData.case_status === 'CLOSED' && selectedStatus === 'IN PROGRESS') {
      const hasResolvedActivity = activities.some(a => a.activity_resolution === 1);
      if (hasResolvedActivity) {
        showPopup({
          title: t('supportCase.warning'),
          message: t('supportCase.resolvedActivityWarning', { markAsResolved: t('supportCase.markAsResolved') }),
          type: 'warning'
        });
        setIsUpdatingStatus(false);
        setShowStatusPopup(false);
        return;
      }
    }
    
    setIsUpdatingStatus(true);
    
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error(t('supportCase.tokenNotFound'));
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      const response = await api.put(`/support-cases/${id}`, {
        ...caseData,
        case_status: selectedStatus,
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
             if (response.data.message === 'Support case updated successfully') {
         setShowStatusSuccessPopup(true);
         // Hemen verileri yenile
         fetchCaseData(); // Refresh case data
         setTimeout(() => {
           setShowStatusSuccessPopup(false);
         }, 1500);
       } else {
        throw new Error(response.data.message || t('statusUpdateFailed'));
      }
    } catch (error) {
      console.error('Error updating case status:', error);
      
      if (error.response && error.response.status === 403) {
        localStorage.removeItem('token');
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.statusUpdateError', { error: error.response?.data?.message || error.message }),
        type: 'error'
      });
    } finally {
      setIsUpdatingStatus(false);
      setShowStatusPopup(false);
    }
  };
  
  const confirmSeverityChange = async () => {
    setIsUpdatingSeverity(true);
    try {
      const response = await api.put(
        `/support-cases/${id}/severity`,
        {
          sla_definition_id: selectedSeverity,
          description: severityDescription
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
      if (response.data.success) {
        setShowSeverityPopup(false);
        showPopup({
          title: t('supportCase.success'),
          message: t('supportCase.severityUpdatedSuccess'),
          type: 'success',
          onConfirm: () => {
            fetchCaseData(); // Refresh case data
          }
        });
      } else {
        throw new Error(response.data.message || t('severityUpdateFailed'));
      }
    } catch (error) {
      console.error('Error updating severity:', error);
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.severityUpdateError', { error: error.response?.data?.message || error.message }),
        type: 'error'
      });
    } finally {
      setIsUpdatingSeverity(false);
    }
  };
  
  // Handle Add Activity button click
  const handleAddActivity = () => {
    // Set default dates to current date and time (Türkiye saati UTC+3)
    const now = new Date();
    // UTC+3 offset ekle
    const turkeyTime = new Date(now.getTime() + (3 * 60 * 60 * 1000));
    const formattedDateTime = turkeyTime.toISOString().slice(0, 16); // Format: YYYY-MM-DDTHH:MM
    
    setActivityData({
      activity_start_date: formattedDateTime,
      activity_end_date: formattedDateTime,
      activity_type: '',
      activity_message: ''
    });
    
    setShowActivityPopup(true);
  };
  
  // Handle activity form input changes
  const handleActivityInputChange = (e) => {
    const { name, value } = e.target;
    setActivityData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  // Submit new activity
  const submitActivity = async () => {
    // Validate form
    if (!activityData.activity_type || !activityData.activity_message) {
      showPopup({
        title: t('supportCase.warning'),
        message: t('supportCase.activityTypeMessageRequired'),
        type: 'error'
      });
      return;
    }
    
    setIsSubmittingActivity(true);
    
    try {
      const response = await api.post(
        '/support-case-activities',
        {
          case_id: id,
          activity_start_date: adjustForTimezone(activityData.activity_start_date),
          activity_end_date: adjustForTimezone(activityData.activity_end_date),
          activity_type: activityData.activity_type,
          activity_message: activityData.activity_message
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
      if (response.data.success) {
        setShowActivityPopup(false);
        showPopup({
          title: t('supportCase.success'),
          message: t('supportCase.activityAddedSuccess'),
          type: 'success',
          onConfirm: () => {
            fetchActivities(); // Refresh activities
          }
        });
      } else {
        throw new Error(response.data.message || t('supportCase.activityAddFailed'));
      }
    } catch (error) {
      console.error('Error adding activity:', error);
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.activityAddError', { error: error.response?.data?.message || error.message }),
        type: 'error'
      });
    } finally {
      setIsSubmittingActivity(false);
    }
  };


  // Toggle dropdown menu
  const toggleDropdown = (activityId) => {
    setOpenDropdownId(openDropdownId === activityId ? null : activityId);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-menu')) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Mark activity as resolved
  const handleMarkAsResolve = (activity) => {
    // Çağrının durumu CLOSED değilse uyarı ver
    if (caseData.case_status !== 'CLOSED') {
      showPopup({
        title: t('supportCase.warning'),
        message: t('supportCase.closeCaseRequired'),
        type: 'warning'
      });
      setOpenDropdownId(null); // Close dropdown
      return;
    }
    
    setSelectedActivityForResolve(activity);
    setShowResolvePopup(true);
    setOpenDropdownId(null); // Close dropdown
  };

  // Confirm mark as resolved
  const confirmMarkAsResolve = async () => {
    if (!selectedActivityForResolve) return;
    
    setIsResolving(true);
    
    try {
      // Sadece activity_id gönder, backend aktivite tablosundan doğru tarihi alacak
      
      const response = await api.put(
        `/support-cases/${id}/resolve`,
        {
          activity_id: selectedActivityForResolve.id
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
             if (response.data.success) {
         setShowResolvePopup(false);
         setSelectedActivityForResolve(null);
         setShowSuccessPopup(true);
         // Hemen verileri yenile
         fetchCaseData(); // Refresh case data
         fetchActivities(); // Refresh activities to get updated activity_resolution
         setTimeout(() => {
           setShowSuccessPopup(false);
         }, 1500);
      } else {
        throw new Error(response.data.message || t('supportCase.operationFailed'));
      }
    } catch (error) {
      console.error('Error marking as resolved:', error);
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.operationError', { error: error.response?.data?.message || error.message }),
        type: 'error'
      });
    } finally {
      setIsResolving(false);
    }
  };

  // Remove mark as resolved
  const handleRemoveMark = (activity) => {
    setSelectedActivityForRemove(activity);
    setShowRemoveMarkPopup(true);
    setOpenDropdownId(null); // Close dropdown
  };

  // Confirm remove mark
  const confirmRemoveMark = async () => {
    if (!selectedActivityForRemove) return;
    
    setIsResolving(true);
    
    try {
      const response = await api.put(
        `/support-cases/${id}/resolve`,
        {
          resolved_time: null,
          activity_id: selectedActivityForRemove.id
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      
             if (response.data.success) {
         setShowRemoveMarkPopup(false);
         setSelectedActivityForRemove(null);
         setShowSuccessPopup(true);
         // Hemen verileri yenile
         fetchCaseData(); // Refresh case data
         fetchActivities(); // Refresh activities to get updated activity_resolution
         setTimeout(() => {
           setShowSuccessPopup(false);
         }, 1500);
      } else {
        throw new Error(response.data.message || t('supportCase.operationFailed'));
      }
    } catch (error) {
      console.error('Error removing mark:', error);
      showPopup({
        title: t('supportCase.error'),
        message: t('supportCase.operationError', { error: error.response?.data?.message || error.message }),
        type: 'error'
      });
    } finally {
      setIsResolving(false);
    }
  };
  
  const fetchSeverityOptions = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error(t('supportCase.tokenNotFound'));
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      // First, we need to get the case data to know which product it's for
      if (!caseData || !caseData.product_id) {
        // Set default options as fallback
        setSeverityOptions([
          { id: 'low', sla_definition_id: 'low', sla_definition_name: 'Low' },
          { id: 'medium', sla_definition_id: 'medium', sla_definition_name: 'Medium' },
          { id: 'high', sla_definition_id: 'high', sla_definition_name: 'High' },
          { id: 'critical', sla_definition_id: 'critical', sla_definition_name: 'Critical' }
        ]);
        return;
      }
      
      try {
        // First, get the SLA group ID for the product
        const productResponse = await api.get(`/products/${caseData.product_id}/sla-group`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (productResponse.data && productResponse.data.sla_group_id) {
          const slaGroupId = productResponse.data.sla_group_id;
          
          // Then get the SLA definitions for that SLA group
          const slaResponse = await api.get(`/sla-groups/${slaGroupId}/definitions`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (slaResponse.data && Array.isArray(slaResponse.data)) {
            setSeverityOptions(slaResponse.data);
          } else {
            throw new Error('Invalid SLA definitions data format');
          }
        } else {
          // If product doesn't have an SLA group assigned, use default options
          console.warn('Product does not have an SLA group assigned');
          setSeverityOptions([
            { id: 'low', sla_definition_id: 'low', sla_definition_name: 'Low' },
            { id: 'medium', sla_definition_id: 'medium', sla_definition_name: 'Medium' },
            { id: 'high', sla_definition_id: 'high', sla_definition_name: 'High' },
            { id: 'critical', sla_definition_id: 'critical', sla_definition_name: 'Critical' }
          ]);
        }
      } catch (productError) {
        console.error('Error fetching product SLA group or definitions:', productError);
        
        // If the product-specific approach fails, try the general SLA definitions endpoint
        try {
          const fallbackResponse = await api.get('/sla-definitions', {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (fallbackResponse.data && Array.isArray(fallbackResponse.data)) {
            setSeverityOptions(fallbackResponse.data);
          } else {
            // If both endpoints fail, set some default options
            setSeverityOptions([
              { id: 'low', sla_definition_id: 'low', sla_definition_name: 'Low' },
              { id: 'medium', sla_definition_id: 'medium', sla_definition_name: 'Medium' },
              { id: 'high', sla_definition_id: 'high', sla_definition_name: 'High' },
              { id: 'critical', sla_definition_id: 'critical', sla_definition_name: 'Critical' }
            ]);
            console.warn('Using default SLA definitions as fallback');
          }
        } catch (fallbackError) {
          console.error('Error fetching general SLA definitions:', fallbackError);
          // Set default options if both API calls fail
          setSeverityOptions([
            { id: 'low', sla_definition_id: 'low', sla_definition_name: 'Low' },
            { id: 'medium', sla_definition_id: 'medium', sla_definition_name: 'Medium' },
            { id: 'high', sla_definition_id: 'high', sla_definition_name: 'High' },
            { id: 'critical', sla_definition_id: 'critical', sla_definition_name: 'Critical' }
          ]);
          console.warn('Using default SLA definitions as fallback');
        }
      }
    } catch (error) {
      console.error('Error in fetchSeverityOptions:', error);
      
      if (error.response && error.response.status === 403) {
        localStorage.removeItem('token');
        navigate('/admin', { state: { message: t('supportCase.sessionExpired') } });
        return;
      }
      
      // Set default options as a last resort
      setSeverityOptions([
        { id: 'low', sla_definition_id: 'low', sla_definition_name: 'Low' },
        { id: 'medium', sla_definition_id: 'medium', sla_definition_name: 'Medium' },
        { id: 'high', sla_definition_id: 'high', sla_definition_name: 'High' },
        { id: 'critical', sla_definition_id: 'critical', sla_definition_name: 'Critical' }
      ]);
      
      showPopup({
        title: t('supportCase.warning'),
        message: t('supportCase.slaDefinitionsWarning'),
        type: 'warning'
      });
    }
  };
  
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  if (!caseData) {
    return (
      <div className="p-6">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <p>Destek talebi bulunamadı. Lütfen geçerli bir destek talebi seçin.</p>
          <button 
            onClick={() => navigate('/support-cases')}
            className="mt-2 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Destek Taleplerine Dön
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="h-full overflow-auto">
      {/* Breadcrumb */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-6">

        <nav className="flex items-center text-xs sm:text-sm">
          <div className="flex items-center bg-[#232b3b] px-4 py-2 rounded-md shadow-sm">
            <Link 
              to="/support-cases" 
              className="text-[#fff] hover:text-[gray] font-medium transition-colors duration-200"
            >
              Support Cases
            </Link>
            <MdChevronRight className="mx-2 text-[#fff]" size={20} />
            <span className="text-[#fff] font-medium">
              {caseData.case_id}
            </span>
          </div>
        </nav>


      </div>
      
      {/* Case Details */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 mb-6">
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 rounded-t-lg flex justify-between items-center">
          <h1 className="text-lg font-medium text-gray-800 dark:text-white">{t('supportCase.caseDetails')}</h1>
          <div className="relative">
            {/* Actions Menu Button */}
            <button
              onClick={() => setShowActionsMenu(!showActionsMenu)}
              className="flex items-center justify-center w-8 h-8 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-600 rounded-md transition-colors"
              title="Actions"
            >
              <CiMenuKebab size={20} />
            </button>
            
            {/* Actions Dropdown Menu */}
            {showActionsMenu && (
              <div className="absolute right-0 top-10 w-48 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-md shadow-lg z-50">
                <div className="py-1">
                  {/* Main Menu Items */}
                  {(caseData.case_owner && JSON.parse(localStorage.getItem('user'))?.id === caseData.case_owner) || (!caseData.case_owner) ? (
                    <>
                      {/* Assign Case - Show if not assigned or if owner and IN PROGRESS */}
                      {(!caseData.case_owner || (caseData.case_owner && caseData.case_status === 'IN PROGRESS')) && (
                        <button
                          onClick={() => {
                            handleAssignCase();
                            setShowActionsMenu(false);
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                        >
                          <MdAssignment size={16} />
                          Assign Case
                        </button>
                      )}
                      
                      {/* Change Status - Show if owner */}
                      {caseData.case_owner && JSON.parse(localStorage.getItem('user'))?.id === caseData.case_owner && (
                        <button
                          onClick={() => {
                            handleChangeStatus();
                            setShowActionsMenu(false);
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                        >
                          <MdUpdate size={16} />
                          Change Status
                        </button>
                      )}
                      
                      {/* Change Severity - Show if owner and not closed */}
                      {caseData.case_owner && JSON.parse(localStorage.getItem('user'))?.id === caseData.case_owner && caseData.case_status !== 'CLOSED' && (
                        <button
                          onClick={() => {
                            handleChangeSeverity();
                            setShowActionsMenu(false);
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                        >
                          <MdPriorityHigh size={16} />
                          Change Severity
                        </button>
                      )}
                      
                      {/* Add Activity - Show if owner and not closed */}
                      {caseData.case_owner && JSON.parse(localStorage.getItem('user'))?.id === caseData.case_owner && caseData.case_status !== 'CLOSED' && (
                        <button
                          onClick={() => {
                            handleAddActivity();
                            setShowActionsMenu(false);
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                        >
                          <MdAddTask size={16} />
                          {t('supportCase.addActivity')}
                        </button>
                      )}
                      
                      {/* Analyze With AI - tüm kullanıcılar görebilir */}
                      <button
                        onClick={() => {
                          setShowAiPopup(true);
                          setShowActionsMenu(false);
                          // Popup açılır açılmaz öneri üret
                          setTimeout(() => generateAiSuggestion(), 0);
                        }}
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                      >
                        <MdSmartToy size={16} />
                        Analyze With AI
                      </button>

                      {/* SLA Statistics - Show if case is closed */}
                      {caseData.case_status === 'CLOSED' && (
                        <button
                          onClick={() => {
                            handleShowSlaStatistics();
                            setShowActionsMenu(false);
                          }}
                          className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                        >
                          <MdPriorityHigh size={16} />
                          {t('supportCase.slaStatistics')}
                        </button>
                      )}
                    </>
                  ) : (
                    /* Take Owner - Show if has owner but current user is not the owner */
                    caseData.case_owner && JSON.parse(localStorage.getItem('user'))?.id !== caseData.case_owner && (
                      <button
                        onClick={() => {
                          handleTakeOwnership();
                          setShowActionsMenu(false);
                        }}
                        className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                      >
                        <MdPersonAdd size={16} />
                        Take Owner
                      </button>
                    )
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="overflow-hidden">
          {/* Desktop Table View */}
          <div className="hidden lg:block">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
                <tr>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400  ">{t('supportCase.caseId')}</td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white">{caseData.case_id}</td>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400">{t('supportCase.customer')}</td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white">{caseData.customer_name}</td>
                </tr>
                <tr>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400">{t('supportCase.status')}</td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white">
                    <div className="flex items-center">
                      {getStatusIcon(caseData.case_status)}
                      <span className="ml-2">{caseData.case_status}</span>
                    </div>
                  </td>
                                   <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400">{t('supportCase.priority')}</td>
                   <td className="px-4 py-2 text-gray-900 dark:text-white">
                     {caseData.severity ? (
                       <div className="relative group">
                         <div className="font-medium cursor-help">
                           {caseData.severity}
                           {(caseData.sla_type || caseData.sla_response_time || caseData.sla_resolution_time) && (
                             <span className="ml-1 text-blue-500">ⓘ</span>
                           )}
                         </div>
                         
                                                 {/* Tooltip */}
                          {(caseData.sla_type || caseData.sla_response_time || caseData.sla_resolution_time) && (
                            <div className="fixed transform -translate-x-1/2 -translate-y-full mt-[-8px] px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-[9999] min-w-[200px]">
                              <div className="space-y-1">
                                {caseData.sla_type && (
                                  <div>
                                    <span className="font-medium">SLA Tipi:</span> {caseData.sla_type}
                                  </div>
                                )}
                                {caseData.sla_response_time && (
                                  <div>
                                    <span className="font-medium">{t('supportCase.responseTime')}</span> {caseData.sla_response_time}
                                  </div>
                                )}
                                {caseData.sla_resolution_time && (
                                  <div>
                                    <span className="font-medium">{t('supportCase.resolutionTime')}</span> {caseData.sla_resolution_time}
                                  </div>
                                )}
                              </div>
                              {/* Tooltip arrow */}
                              <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                            </div>
                          )}
                       </div>
                     ) : (
                       t('supportCase.notSpecified')
                     )}
                   </td>
                </tr>
                <tr>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400">{t('supportCase.creator')}</td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white">{caseData.created_by_name}</td>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400">{t('supportCase.assigned')}</td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white">{caseData.assigned_to_name || t('supportCase.notAssignedYet')}</td>
                </tr>
                <tr>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400">{t('supportCase.createdAt')}</td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white">{formatDate(caseData.created_at)}</td>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400">{t('supportCase.source')}</td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white">{caseData.source}</td>
                </tr>
                <tr>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400">{t('supportCase.product')}</td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white">{caseData.product_name || t('supportCase.notSpecified')}</td>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400"></td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white"></td>
                </tr>
                <tr>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400">{t('supportCase.subject')}</td>
                  <td className="px-4 py-2 text-gray-900 dark:text-white" colSpan="3">{caseData.subject}</td>
                </tr>
                <tr>
                  <td className="px-4 py-2 bg-gray-50 dark:bg-gray-700 text-sm font-medium text-gray-500 dark:text-gray-400 rounded-bl-lg ">{t('supportCase.detail')}</td>
                  <td className="px-4 py-2 whitespace-pre-line text-gray-900 dark:text-white" colSpan="3">{caseData.detail}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className="lg:hidden space-y-4 p-4">
            {/* Case ID & Customer */}
            <div className="grid grid-cols-1 gap-4">
              <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.caseId')}</div>
                <div className="text-gray-900 dark:text-white">{caseData.case_id}</div>
              </div>
              <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.customer')}</div>
                <div className="text-gray-900 dark:text-white">{caseData.customer_name}</div>
              </div>
            </div>

            {/* Status & Priority */}
            <div className="grid grid-cols-1 gap-4">
              <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.status')}</div>
                <div className="text-gray-900 dark:text-white">
                  <div className="flex items-center">
                    {getStatusIcon(caseData.case_status)}
                    <span className="ml-2">{caseData.case_status}</span>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.priority')}</div>
                <div className="text-gray-900 dark:text-white">
                  {caseData.severity ? (
                    <div className="relative group">
                      <div className="font-medium cursor-help">
                        {caseData.severity}
                        {(caseData.sla_type || caseData.sla_response_time || caseData.sla_resolution_time) && (
                          <span className="ml-1 text-blue-500">ⓘ</span>
                        )}
                      </div>
                      
                      {/* Tooltip */}
                      {(caseData.sla_type || caseData.sla_response_time || caseData.sla_resolution_time) && (
                        <div className="fixed transform -translate-x-1/2 -translate-y-full mt-[-8px] px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-[9999] min-w-[200px]">
                          <div className="space-y-1">
                            {caseData.sla_type && (
                              <div>
                                <span className="font-medium">SLA Tipi:</span> {caseData.sla_type}
                              </div>
                            )}
                            {caseData.sla_response_time && (
                              <div>
                                <span className="font-medium">{t('supportCase.responseTime')}</span> {caseData.sla_response_time}
                              </div>
                            )}
                            {caseData.sla_resolution_time && (
                              <div>
                                <span className="font-medium">{t('supportCase.resolutionTime')}</span> {caseData.sla_resolution_time}
                              </div>
                            )}
                          </div>
                          {/* Tooltip arrow */}
                          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900"></div>
                        </div>
                      )}
                    </div>
                  ) : (
                    t('supportCase.notSpecified')
                  )}
                </div>
              </div>
            </div>

            {/* Creator & Assigned */}
            <div className="grid grid-cols-1 gap-4">
              <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.creator')}</div>
                <div className="text-gray-900 dark:text-white">{caseData.created_by_name}</div>
              </div>
              <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.assigned')}</div>
                <div className="text-gray-900 dark:text-white">{caseData.assigned_to_name || t('supportCase.notAssignedYet')}</div>
              </div>
            </div>

            {/* Created At & Source */}
            <div className="grid grid-cols-1 gap-4">
              <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.createdAt')}</div>
                <div className="text-gray-900 dark:text-white">{formatDate(caseData.created_at)}</div>
              </div>
              <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
                <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.source')}</div>
                <div className="text-gray-900 dark:text-white">{caseData.source}</div>
              </div>
            </div>

            {/* Product */}
            <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
              <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.product')}</div>
              <div className="text-gray-900 dark:text-white">{caseData.product_name || t('supportCase.notSpecified')}</div>
            </div>

            {/* Subject */}
            <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
              <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.subject')}</div>
              <div className="text-gray-900 dark:text-white">{caseData.subject}</div>
            </div>

            {/* Detail */}
            <div className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg">
              <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.detail')}</div>
              <div className="text-gray-900 dark:text-white whitespace-pre-line">{caseData.detail}</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* AI Öneri Popup */}
      {showAiPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
          <div className="relative mx-auto w-full max-w-xl max-h-[80vh] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
            {/* Başlık */}
            <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-medium flex items-center gap-2">
                <MdSmartToy size={20} /> Analyze With AI
              </h3>
              <button onClick={() => setShowAiPopup(false)} className="text-gray-300 hover:text-white">
                <MdClose size={24} />
              </button>
            </div>
            {/* İçerik */}
            <div className="p-6 overflow-auto max-h-[calc(80vh-140px)]">
              {/* Açıklayıcı metin */}
              <p className="text-sm text-gray-700 dark:text-gray-300 mb-3">
                Bu metin, Subject ve Detail alanları temel alınarak oluşturulmuştur.
              </p>
              <div className="border border-gray-200 dark:border-gray-700 rounded-md p-4 bg-gray-50 dark:bg-gray-700 min-h-[160px]">
                {isGeneratingAi ? (
                  <div className="flex items-center gap-3 text-gray-600 dark:text-gray-300">
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#272c39]"></div>
                    <span>Öneri oluşturuluyor...</span>
                  </div>
                ) : (
                  <pre className="whitespace-pre-wrap text-sm text-gray-900 dark:text-white">{aiSuggestion}</pre>
                )}
              </div>
            </div>
            {/* Alt butonlar */}
            <div className="px-6 py-4 bg-gray-50 dark:bg-gray-700 flex justify-between">
              <button
                onClick={generateAiSuggestion}
                disabled={isGeneratingAi}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-60 flex items-center gap-2"
              >
                <MdRefresh size={16} />
                Retry Analyze
              </button>
              <div className="flex gap-3">
                <button
                  onClick={() => setShowAiPopup(false)}
                  className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500"
                >
                  Kapat
                </button>
                <button
                  onClick={addAiToActivity}
                  disabled={isGeneratingAi || !aiSuggestion}
                  className="px-4 py-2 bg-[#272c39] text-white rounded-md hover:bg-[#1e2230] disabled:opacity-60"
                >
                  Add comment to Activity
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* File Upload Section */}
      {caseData.case_status !== 'CLOSED' && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 mb-6 ">
                  <div 
          className={`px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 flex justify-between items-center cursor-pointer rounded-tl-lg rounded-tr-lg ${!isUploadSectionExpanded ? 'rounded-bl-lg rounded-br-lg' : ''}`}
          onClick={() => setIsUploadSectionExpanded(!isUploadSectionExpanded)}
        >
            <h2 className="text-lg font-medium text-gray-800 dark:text-white ">{t('supportCase.fileUpload')}</h2>
            <MdExpandMore 
              size={24} 
              className={`text-gray-500 dark:text-gray-400 transform transition-transform duration-200 ${isUploadSectionExpanded ? 'rotate-180' : ''}`}
            />
          </div>
          {isUploadSectionExpanded && (
            <div>
              <div className="p-6">
                <div className="mb-4">
                  <label htmlFor="fileDescription" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.fileDescription')}
                  </label>
                  <input
                    type="text"
                    id="fileDescription"
                    value={fileDescription}
                    onChange={(e) => setFileDescription(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder={t('supportCase.enterFileDescription')}
                  />
                </div>
                
                <div 
                  className={`border-2 border-dashed rounded-md p-6 ${
                    dragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
                  }`}
                  onDragEnter={handleDrag}
                  onDragOver={handleDrag}
                  onDragLeave={handleDrag}
                  onDrop={handleDrop}
                >
                  <div className="text-center">
                    <MdUpload className="mx-auto h-12 w-12 text-gray-400" />
                    <div className="mt-2">
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {t('supportCase.dragFilesHere')}
                      </p>
                      <button
                        type="button"
                        className="mt-2 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        onClick={openFileSelector}
                        disabled={isUploading}
                      >
{isUploading ? t('supportCase.uploading') : t('supportCase.selectFiles')}
                      </button>
                      <input
                        ref={fileInputRef}
                        type="file"
                        multiple
                        className="hidden"
                        onChange={handleFileInputChange}
                        disabled={isUploading}
                      />
                    </div>
                    <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ">
                      PDF, Word, Excel, PowerPoint, ZIP, TXT, LOG (max. 10MB)
                    </p>
                  </div>
                </div>
              </div>

              {/* Files Table */}
              <div className="border-t border-gray-200 dark:border-gray-700">
                <div className="px-3 sm:px-4 lg:px-6 py-2 sm:py-3 lg:py-4 border-b border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700">
                  <h2 className="text-sm sm:text-base lg:text-lg font-medium text-gray-800 dark:text-white">{t('supportCase.uploadedFiles')}</h2>
                </div>
                
                {/* Desktop Table View */}
                <div className="hidden lg:block overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-600">
                    <thead className="bg-gray-50 dark:bg-gray-700">
                      <tr>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.fileName')}
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.description')}
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.uploader')}
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.uploadDate')}
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.actions')}
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-600">
                      {!files || files.length === 0 ? (
                        <tr>
                          <td colSpan="5" className="px-4 py-2 text-center text-gray-500 dark:text-gray-400 rounded-bl-lg rounded-br-lg">
{t('supportCase.noFilesUploadedYet')}
                          </td>
                        </tr>
                      ) : (
                        Array.isArray(files) && files.map((file, index) => {
                          const isLast = index === files.length - 1;
                          return (
                            <tr key={file.id}>
                              {/* İlk hücre: Eğer son satırsa ve tablo kapalıysa sol alt köşe yuvarlatılır */}
                              <td className={`px-4 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400 rounded-bl-lg rounded-br-lg ${isLast && !isUploadSectionExpanded ? 'rounded-bl-lg' : ''}`}>
                                {file.filename}
                              </td>
                              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                {file.file_description || t('supportCase.noDescription')}
                              </td>
                              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                {file.uploaded_by_name || file.uploaded_by || 'Bilinmiyor'}
                              </td>
                              <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                {formatDate(file.created_at)}
                              </td>
                              {/* Son hücre: Eğer son satırsa ve tablo kapalıysa sağ alt köşe yuvarlatılır */}
                              <td className={`px-4 py-2 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400 rounded-bl-lg rounded-br-lg ${isLast && !isUploadSectionExpanded ? 'rounded-br-lg' : ''}`}>
                                <div className="flex items-center space-x-3">
                                  <button
                                    onClick={() => handleDownloadFile(file.id, file.filename || file.original_name || file.file_name)}
                                    className="text-blue-600 hover:text-blue-800"
                                    title={t('supportCase.download')}
                                  >
                                    <MdDownload size={20} />
                                  </button>
                                  {caseData.case_status !== 'CLOSED' && (
                                    <button
                                      onClick={() => handleDeleteFile(file.id)}
                                      className="text-red-600 hover:text-red-800"
                                      title={t('supportCase.delete')}
                                    >
                                      <MdDelete size={20} />
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Mobile Card View */}
                <div className="lg:hidden p-3 sm:p-4">
                  {!files || files.length === 0 ? (
                    <div className="text-center py-4">
                      <p className="text-gray-400 dark:text-gray-500 text-xs sm:text-sm">{t('supportCase.noFilesUploadedYet')}</p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {Array.isArray(files) && files.map((file, index) => (
                        <div key={file.id} className="bg-gray-50 dark:bg-gray-700 p-3 rounded-lg border border-gray-200 dark:border-gray-600">
                          <div className="space-y-2">
                            {/* File Name */}
                            <div className="flex justify-between items-start">
                              <span className="text-xs font-medium text-gray-500 dark:text-gray-400">{t('supportCase.fileName')}</span>
                              <span className="text-xs text-gray-700 dark:text-gray-300 font-medium truncate max-w-[200px]">{file.filename}</span>
                            </div>
                            
                            {/* Description */}
                            <div>
                              <span className="text-xs font-medium text-gray-500 dark:text-gray-400">{t('supportCase.description')}</span>
                              <p className="text-xs text-gray-700 dark:text-gray-300 mt-1 line-clamp-2">
                                {file.file_description || t('supportCase.noDescription')}
                              </p>
                            </div>
                            
                            {/* Uploader & Date */}
                            <div className="grid grid-cols-2 gap-3">
                              <div>
                                <span className="text-xs font-medium text-gray-500 dark:text-gray-400">{t('supportCase.uploader')}</span>
                                <p className="text-xs text-gray-700 dark:text-gray-300 mt-1">
                                  {file.uploaded_by_name || file.uploaded_by || 'Bilinmiyor'}
                                </p>
                              </div>
                              <div>
                                <span className="text-xs font-medium text-gray-500 dark:text-gray-400">{t('supportCase.uploadDate')}</span>
                                <p className="text-xs text-gray-700 dark:text-gray-300 mt-1">
                                  {formatDate(file.created_at)}
                                </p>
                              </div>
                            </div>
                            
                            {/* Actions */}
                            <div className="flex justify-end items-center gap-2 pt-2 border-t border-gray-200 dark:border-gray-600">
                              <button
                                onClick={() => handleDownloadFile(file.id, file.filename || file.original_name || file.file_name)}
                                className="text-blue-600 hover:text-blue-800 p-1"
                                title={t('supportCase.download')}
                              >
                                <MdDownload size={16} />
                              </button>
                              {caseData.case_status !== 'CLOSED' && (
                                <button
                                  onClick={() => handleDeleteFile(file.id)}
                                  className="text-red-600 hover:text-red-800 p-1"
                                  title={t('supportCase.delete')}
                                >
                                  <MdDelete size={16} />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      
      {/* Take Ownership Popup */}
      {showOwnerPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9000] flex items-center justify-center">
          <div className="relative mx-auto w-full max-w-md max-h-[50vh] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
            {/* Header */}
            <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-medium">
                Destek Talebini Üzerinize Alın
              </h3>
              <button 
                onClick={() => setShowOwnerPopup(false)} 
                className="text-gray-300 hover:text-white"
              >
                <MdClose size={24} />
              </button>
            </div>
            
            {/* Form Content */}
            <div className="p-6">
              <p className="text-gray-700 dark:text-gray-300 mb-4">{t('supportCase.confirmTakeOver')}</p>
              
              <div className="mb-4">
                <label htmlFor="notificationMessage" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.notificationMessage')}
                </label>
                <textarea
                  id="notificationMessage"
                  value={notificationMessage}
                  onChange={(e) => setNotificationMessage(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows={5}
                />
              </div>
              
              {/* Buttons */}
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setShowOwnerPopup(false)}
                  className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500"
                >
{t('supportCase.cancel')}
                </button>
                <button
                  onClick={confirmTakeOwnership}
                  className="px-4 py-2 bg-[#272c39] text-white rounded-md hover:bg-[#1e2230]"
                  disabled={isUpdatingOwner}
                >
                  {isUpdatingOwner ? t('supportCase.processing') : t('supportCase.ok')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Assign Case Popup */}
      {showAssignPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9000] flex items-center justify-center">
          <div className="relative mx-auto w-full max-w-md max-h-[50vh] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
            {/* Header */}
            <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-medium">
                {t('supportCase.assignSupportTicket')}
              </h3>
              <button 
                onClick={() => setShowAssignPopup(false)} 
                className="text-gray-300 hover:text-white"
              >
                <MdClose size={24} />
              </button>
            </div>
            
            {/* Form Content */}
            <div className="p-6">
              <div className="mb-4">
                <label htmlFor="agentSelect" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.selectAgent')}
                </label>
                                 <select
                   id="agentSelect"
                   value={selectedAgent}
                   onChange={(e) => {
                     setSelectedAgent(e.target.value);
                     // {t('selectedAgentName')}
                     const selectedAgentData = agents.find(agent => agent.id == e.target.value);
                     if (selectedAgentData) {
                       const updatedMessage = `Merhabalar, oluşturmuş olduğunuz destek talebi ile ilgili sizlere ben yardımcı olacağım. Case ile ilgili detayları inceleyip en kısa zamanda dönüş sağlayacağım.\n\n[${selectedAgentData.full_name}]`;
                       setNotificationMessage(updatedMessage);
                     }
                   }}
                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                 >
                   <option value="">{t('supportCase.selectAgent')}</option>
                   {agents.map(agent => (
                     <option key={agent.id} value={agent.id}>
                       {agent.full_name}
                     </option>
                   ))}
                 </select>
              </div>
              
              <div className="mb-4">
                <label htmlFor="assignNotificationMessage" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.assignNotificationMessage')}
                </label>
                <textarea
                  id="assignNotificationMessage"
                  value={notificationMessage}
                  onChange={(e) => setNotificationMessage(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  rows={5}
                />
              </div>
              
              {/* Buttons */}
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setShowAssignPopup(false)}
                  className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500"
                >
{t('supportCase.cancel')}
                </button>
                <button
                  onClick={confirmAssignCase}
                  className="px-4 py-2 bg-[#272c39] text-white rounded-md hover:bg-[#1e2230]"
                  disabled={isUpdatingOwner}
                >
                  {isUpdatingOwner ? t('supportCase.processing') : t('supportCase.ok')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Popup */}
      {popup.show && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
          <div className="relative mx-auto p-8 border w-full max-w-sm shadow-lg rounded-md bg-white dark:bg-gray-800">
            <div className="mt-4 text-center">
              <h3 className="text-xl leading-6 font-medium text-gray-900 dark:text-white mb-4">
                {popup.title}
              </h3>
              <div className="mt-4 px-8 py-4">
                <p className="text-base text-gray-600 dark:text-gray-400">
                  {popup.message}
                </p>
              </div>
              <div className="flex justify-center gap-4 px-8 py-4 mt-2">
                {popup.showCancel && (
                  <button
                    onClick={closePopup}
                    className="px-6 py-2.5 bg-gray-200 text-gray-800 dark:text-white text-base font-medium rounded-md shadow-sm hover:bg-gray-300 focus:outline-none min-w-[120px]"
                  >
  {t('supportCase.cancel')}
                  </button>
                )}
                <button
                  onClick={confirmPopup}
                  className={`px-6 py-2.5 text-white text-base font-medium rounded-md shadow-sm focus:outline-none min-w-[120px] ${
                    popup.type === 'error' 
                      ? 'bg-red-600 hover:bg-red-700'
                      : popup.type === 'success'
                      ? 'bg-green-600 hover:bg-green-700'
                      : 'bg-[#272c39] hover:bg-[#1e2230]'
                  }`}
                >
                  Tamam
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Change Status Popup */}
      {showStatusPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9000] flex items-center justify-center">
          <div className="relative mx-auto w-full max-w-md max-h-[50vh] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
            {/* Header */}
            <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-medium">
                {t('supportCase.changeSupportTicketStatus')}
              </h3>
              <button 
                onClick={() => setShowStatusPopup(false)} 
                className="text-gray-300 hover:text-white"
              >
                <MdClose size={24} />
              </button>
            </div>
            
            {/* Form Content */}
            <div className="p-6">
              <p className="text-gray-700 dark:text-gray-300 mb-4">{t('supportCase.selectNewStatus')}</p>
              
              <div className="mb-4">
                <label htmlFor="statusSelect" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.statusLabel')}
                </label>
                <select
                  id="statusSelect"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="IN PROGRESS">{t('supportCase.inProgress')}</option>
                  <option value="CLOSED">{t('supportCase.closed')}</option>
                </select>
              </div>
              
              {/* Buttons */}
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setShowStatusPopup(false)}
                  className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500"
                >
{t('supportCase.cancel')}
                </button>
                <button
                  onClick={confirmStatusChange}
                  className="px-4 py-2 bg-[#272c39] text-white rounded-md hover:bg-[#1e2230]"
                  disabled={isUpdatingStatus}
                >
                  {isUpdatingStatus ? t('supportCase.processing') : t('supportCase.ok')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* SLA Modal */}
      {showSlaModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
          <div className="relative mx-auto w-full max-w-full sm:max-w-lg max-h-[85vh] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden mx-3">
            {/* Header */}
            <div className="bg-[#272c39] text-white px-4 py-3 sm:px-6 sm:py-4 flex justify-between items-center">
              <h3 className="text-base sm:text-lg font-medium">{t('supportCase.slaStatistics')}</h3>
              <button 
                onClick={() => setShowSlaModal(false)} 
                className="text-white hover:text-gray-200"
              >
                <MdClose size={24} />
              </button>
            </div>
            {/* Content */}
            <div className="p-4 sm:p-6">
              {isLoadingSlaStats ? (
                <div className="flex items-center justify-center py-6 sm:py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#272c39]"></div>
                  <span className="ml-3 text-xs sm:text-sm text-gray-600 dark:text-gray-400">{t('slaStatsLoading')}</span>
                </div>
                            ) : slaStatistics ? (
                <div className="space-y-4 sm:space-y-6">

                  {/* SLA Tanımları */}
                  <div className="bg-gray-50 dark:bg-gray-700 p-3 sm:p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 dark:text-white mb-2 sm:mb-3 pb-2 border-b border-gray-300 dark:border-gray-600 text-sm sm:text-base">{t('supportCase.slaDefinitions')}</h4>
                    <div className="grid grid-cols-2 gap-3 sm:gap-4 text-xs sm:text-sm">
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white mb-0.5 text-xs sm:text-sm">{t('supportCase.slaType')}</div>
                        <div className="text-gray-600 dark:text-gray-400">
                          {slaStatistics.slaType || t('supportCase.notSpecified')}
                        </div>
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white mb-0.5 text-xs sm:text-sm">{t('supportCase.slaSeverity')}</div>
                        <div className="text-gray-600 dark:text-gray-400">
                          {slaStatistics.slaSeverity || t('supportCase.notSpecified')}
                        </div>
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white mb-0.5 text-xs sm:text-sm">{t('supportCase.responseTime')}</div>
                        <div className="text-gray-600 dark:text-gray-400">
                          {slaStatistics.slaResponseTime ? `${slaStatistics.slaResponseTime} ${t('supportCase.minutes')}` : t('supportCase.notSpecified')}
                        </div>
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white mb-0.5 text-xs sm:text-sm">{t('supportCase.resolutionTime')}</div>
                        <div className="text-gray-600 dark:text-gray-400">
                          {slaStatistics.slaResolutionTime ? `${slaStatistics.slaResolutionTime} ${t('supportCase.minutes')}` : t('supportCase.notSpecified')}
                        </div>
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white mb-0.5 text-xs sm:text-sm">{t('supportCase.workHours')}</div>
                        <div className="text-gray-600 dark:text-gray-400">
                          {slaStatistics.workingHoursStart} - {slaStatistics.workingHoursEnd}
                        </div>
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white mb-0.5 text-xs sm:text-sm">{t('supportCase.workDays')}</div>
                        <div className="text-gray-600 dark:text-gray-400">
                          {slaStatistics.workingDays.map(day => {
                            const dayNames = ['', t('supportCase.monday'), t('supportCase.tuesday'), t('supportCase.wednesday'), t('supportCase.thursday'), t('supportCase.friday'), t('supportCase.saturday'), t('supportCase.sunday')];
                            return dayNames[day];
                          }).join(', ')}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Zaman Bilgileri */}
                  <div className="bg-gray-50 dark:bg-gray-700 p-3 sm:p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 dark:text-white mb-2 sm:mb-3 pb-2 border-b border-gray-300 dark:border-gray-600 text-sm sm:text-base">Zaman Bilgileri</h4>
                    <div className="space-y-2.5 sm:space-y-3 text-xs sm:text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-600 dark:text-gray-400">{t('supportCase.creationTime')}</span>
                        <span className="font-medium text-gray-900 dark:text-white">
                          {new Date(slaStatistics.createdAt).toLocaleString('tr-TR')}
                        </span>
                      </div>
                      {slaStatistics.firstResponseTime && (
                        <div className="flex justify-between">
                          <span className="text-gray-600 dark:text-gray-400">{t('supportCase.firstResponseTime')}</span>
                          <span className="font-medium text-gray-900 dark:text-white">
                            {new Date(slaStatistics.firstResponseTime).toLocaleString('tr-TR')}
                          </span>
                        </div>
                      )}
                      {slaStatistics.resolvedTime && (
                        <div className="flex justify-between">
                          <span className="text-gray-600 dark:text-gray-400">{t('supportCase.resolutionTimeLabel')}</span>
                          <span className="font-medium text-gray-900 dark:text-white">
                            {new Date(slaStatistics.resolvedTime).toLocaleString('tr-TR')}
                          </span>
                        </div>
                      )}
                      {slaStatistics.closedAt && (
                        <div className="flex justify-between">
                          <span className="text-gray-600 dark:text-gray-400">{t('supportCase.closureTime')}</span>
                          <span className="font-medium text-gray-900 dark:text-white">
                            {new Date(slaStatistics.closedAt).toLocaleString('tr-TR')}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* SLA Performansı */}
                  <div className="bg-gray-50 dark:bg-gray-700 p-3 sm:p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-900 dark:text-white mb-2 sm:mb-3 pb-2 border-b border-gray-300 dark:border-gray-600 text-sm sm:text-base">{t('supportCase.slaPerformance')}</h4>
                    <div className="space-y-3 sm:space-y-4">
                      {/* Yanıt Süresi */}
                      <div className="border-l-4 border-blue-500 pl-4">
                        <div className="flex justify-between items-center mb-1.5 sm:mb-2">
                          <span className="text-xs sm:text-sm font-medium text-gray-900 dark:text-white">{t('supportCase.responseTimeLabel')}</span>
                          <span className={`px-2 py-0.5 sm:py-1 rounded-full text-[10px] sm:text-xs font-medium ${
                            slaStatistics.isResponseWithinSLA 
                              ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' 
                              : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                          }`}>
                            {slaStatistics.isResponseWithinSLA ? t('supportCase.withinSLA') : t('supportCase.outsideSLA')}
                          </span>
                        </div>
                        <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                          <span>Gerçekleşen: </span>
                          <span className="font-medium text-gray-900 dark:text-white">{slaStatistics.responseTimeFormatted}</span>
                          {slaStatistics.slaResponseTime && (
                            <>
                              <span className="mx-2">/</span>
                              <span className="font-medium text-gray-900 dark:text-white">{slaStatistics.slaResponseTime} dakika</span>
                            </>
                          )}
                        </div>
                      </div>

                      {/* Çözüm Süresi */}
                      {slaStatistics.caseStatus === 'CLOSED' && slaStatistics.resolvedTime && (
                        <div className="border-l-4 border-green-500 pl-4">
                          <div className="flex justify-between items-center mb-1.5 sm:mb-2">
                            <span className="text-xs sm:text-sm font-medium text-gray-900 dark:text-white">{t('supportCase.resolutionTimeLabel2')}</span>
                            <span className={`px-2 py-0.5 sm:py-1 rounded-full text-[10px] sm:text-xs font-medium ${
                              slaStatistics.isResolutionWithinSLA 
                                ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' 
                                : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                            }`}>
                              {slaStatistics.isResolutionWithinSLA ? t('supportCase.withinSLA') : t('supportCase.outsideSLA')}
                            </span>
                          </div>
                          <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                            <span>Gerçekleşen: </span>
                            <span className="font-medium text-gray-900 dark:text-white">{slaStatistics.resolutionTimeFormatted}</span>
                            {slaStatistics.slaResolutionTime && (
                              <>
                                <span className="mx-2">/</span>
                                <span className="font-medium text-gray-900 dark:text-white">{slaStatistics.slaResolutionTime} dakika</span>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-gray-700 dark:text-gray-300">
                  <p>SLA istatistikleri yüklenemedi.</p>
                </div>
              )}
              
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setShowSlaModal(false)}
                  className="px-4 py-2 bg-[#272c39] text-white rounded-md hover:bg-[#1e2230]"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Change Severity Popup */}
      {showSeverityPopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9000] flex items-center justify-center">
          <div className="relative mx-auto w-full max-w-md max-h-[50vh] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
            {/* Header */}
            <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-medium">
                {t('supportCase.changeSupportTicketSeverity')}
              </h3>
              <button 
                onClick={() => setShowSeverityPopup(false)} 
                className="text-gray-300 hover:text-white"
              >
                <MdClose size={24} />
              </button>
            </div>
            
            {/* Form Content */}
            <div className="p-6">
              <p className="text-gray-700 dark:text-gray-300 mb-4">{t('supportCase.selectNewSeverity')}</p>
              
              <div className="mb-4">
                <label htmlFor="severitySelect" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.severityLevel')}
                </label>
                <select
                  id="severitySelect"
                  value={selectedSeverity}
                  onChange={(e) => setSelectedSeverity(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">{t('supportCase.selectSeverityLevel')}</option>
                  {severityOptions.map(option => (
                    <option key={option.id} value={option.id}>
                      {option.sla_definition_name || option.severity || option.sla_severity}
                    </option>
                  ))}
                </select>
              </div>
              
              <div className="mb-4">
                <label htmlFor="severityDescription" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.descriptionOptional')}
                </label>
                <textarea
                  id="severityDescription"
                  value={severityDescription}
                  onChange={(e) => setSeverityDescription(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows={3}
                  placeholder={t('supportCase.severityDescriptionPlaceholder')}
                />
              </div>
              
              {/* Buttons */}
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setShowSeverityPopup(false)}
                  className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500"
                >
{t('supportCase.cancel')}
                </button>
                <button
                  onClick={confirmSeverityChange}
                  className="px-4 py-2 bg-[#272c39] text-white rounded-md hover:bg-[#1e2230]"
                  disabled={isUpdatingSeverity}
                >
                  {isUpdatingSeverity ? t('supportCase.processing') : t('supportCase.ok')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
             {/* Add Activity Popup */}
       {showActivityPopup && (
         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9000] flex items-center justify-center p-4">
           <div className="relative mx-auto w-full max-w-md max-h-[90vh] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
            {/* Header */}
            <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-medium">
{t('supportCase.addActivityTitle')}
              </h3>
              <button 
                onClick={() => setShowActivityPopup(false)} 
                className="text-gray-300 hover:text-white"
              >
                <MdClose size={24} />
              </button>
            </div>
            
            {/* Form Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
              <p className="text-gray-700 dark:text-gray-300 mb-4">{t('supportCase.enterActivityInfo')}</p>
              
              <div className="mb-4">
                <label htmlFor="activity_start_date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.activityStartDateTime')}
                </label>
                <input
                  type="datetime-local"
                  id="activity_start_date"
                  name="activity_start_date"
                  value={activityData.activity_start_date}
                  onChange={handleActivityInputChange}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              
              <div className="mb-4">
                <label htmlFor="activity_end_date" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.activityEndDateTime')}
                </label>
                <input
                  type="datetime-local"
                  id="activity_end_date"
                  name="activity_end_date"
                  value={activityData.activity_end_date}
                  onChange={handleActivityInputChange}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              
              <div className="mb-4">
                <label htmlFor="activity_type" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.activityType')}
                </label>
                <select
                  id="activity_type"
                  name="activity_type"
                  value={activityData.activity_type}
                  onChange={handleActivityInputChange}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 "
                >
                  <option value="">{t('supportCase.selectActivityType')}</option>
                  <option value="Remote">{t('supportCase.remoteSupport')}</option>
                  <option value="Phone">{t('supportCase.phone')}</option>
                  <option value="Email">{t('supportCase.email')}</option>
                  <option value="OnSite">{t('supportCase.onSiteSupport')}</option>
                  <option value="Other">{t('supportCase.other')}</option>
                </select>
              </div>
              
              <div className="mb-4">
                <label htmlFor="activity_message" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
{t('supportCase.activityDetail')}
                </label>
                <textarea
                  id="activity_message"
                  name="activity_message"
                  value={activityData.activity_message}
                  onChange={handleActivityInputChange}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows={4}
                  placeholder={t('supportCase.activityDetailPlaceholder')}
                />
              </div>
              
              {/* Buttons */}
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setShowActivityPopup(false)}
                  className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500"
                >
{t('supportCase.cancel')}
                </button>
                <button
                  onClick={submitActivity}
                  className="px-4 py-2 bg-[#272c39] text-white rounded-md hover:bg-[#1e2230]"
                  disabled={isSubmittingActivity}
                >
{isSubmittingActivity ? t('supportCase.processing') : t('supportCase.save')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      

       
       {/* Activities Table */}
       <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 mt-6">
        <div 
          className={`px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 flex justify-between items-center cursor-pointer rounded-tl-lg rounded-tr-lg ${!isActivitiesTableExpanded ? 'rounded-bl-lg rounded-br-lg' : ''}`}
          onClick={() => setIsActivitiesTableExpanded(!isActivitiesTableExpanded)}
        >
          <h2 className="text-lg font-medium text-gray-800 dark:text-white ">{t('supportCase.activities')}</h2>
          <MdExpandMore 
            size={24} 
            className={`text-gray-500 dark:text-gray-400 transform transition-transform duration-200 ${isActivitiesTableExpanded ? 'rotate-180' : ''}`}
          />
        </div>
        {isActivitiesTableExpanded && (
          <div className="overflow-hidden">
            {/* Desktop Table View */}
            <div className="hidden lg:block">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-600">
                                                                     <thead className="bg-gray-50 dark:bg-gray-700">
                       <tr>
                         <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.activityType')}
                         </th>
                         <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.startTime')}
                         </th>
                         <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.endTime')}
                         </th>
                         <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.activityDetail')}
                         </th>
                         <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.creator')}
                         </th>
                         <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
{t('supportCase.actions')}
                         </th>
                       </tr>
                     </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-600">
                {activities.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="px-4 py-2 text-center text-gray-500 dark:text-gray-400 rounded-bl-lg rounded-br-lg">
{t('supportCase.noActivitiesFound')}
                    </td>
                  </tr>
                ) : (
                  activities.map((activity, index) => {
                    const isLast = index === activities.length - 1;
                                         return (
                                               <tr 
                          key={index} 
                          className={`${
                            activity.activity_resolution === 1 ? 'bg-green-100 dark:bg-green-800/30' : 'bg-white dark:bg-gray-800'
                          }`}
                        >
                        {/* İlk hücre: Eğer son satırsa ve tablo kapalıysa sol alt köşe yuvarlatılır */}
                        <td className={`px-4 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-white rounded-bl-lg rounded-br-lg ${isLast && !isActivitiesTableExpanded ? 'rounded-bl-lg' : ''}`}>
                          {activity.activity_type}
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                          {new Date(activity.activity_start_date).toLocaleString('tr-TR')}
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                          {new Date(activity.activity_end_date).toLocaleString('tr-TR')}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-900 dark:text-white">
                          {activity.activity_message}
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                          {activity.created_by}
                        </td>
                                                                           {/* İşlemler hücresi */}
                          <td className={`px-4 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-white rounded-bl-lg rounded-br-lg ${isLast && !isActivitiesTableExpanded ? 'rounded-br-lg' : ''}`}>
                            {/* Sadece support_case_comment = 1 olan aktivitelerde dropdown menü göster */}
                            {activity.support_case_comment === 1 && (
                              <div className="relative dropdown-menu flex justify-center">
                                <button
                                  onClick={() => toggleDropdown(activity.id)}
                                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 p-1 rounded"
                                  title={t('supportCase.actions')}
                                >
                                  <CiMenuKebab size={20} />
                                </button>
                               
                                                               {/* Dropdown Menu */}
                                {openDropdownId === activity.id && (
                                  <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-md shadow-lg z-50 border border-gray-200 dark:border-gray-700">
                                    <div className="py-1">
                                                                             {activity.activity_resolution !== 1 ? (
                                         // {t('markAsResolveComment')}
                                         !activities.some(a => a.activity_resolution === 1) ? (
                                           <button
                                             onClick={() => handleMarkAsResolve(activity)}
                                             className="block w-full text-left px-4 py-2 text-sm text-green-600 hover:bg-green-50 dark:hover:bg-green-900 dark:text-green-400"
                                           >
{t('supportCase.markAsResolved')}
                                           </button>
                                         ) : (
                                           <span className="block w-full text-left px-4 py-2 text-sm text-gray-400 cursor-not-allowed">
{t('supportCase.markAsResolved')}
                                           </span>
                                         )
                                      ) : (
                                        <button
                                          onClick={() => handleRemoveMark(activity)}
                                          className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 dark:hover:bg-red-900 dark:text-red-400"
                                        >
                                          Remove Mark
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )}
                             </div>
                           )}
                         </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
            </div>

            {/* Mobile Card View */}
            <div className="lg:hidden space-y-4 p-4">
              {activities.length === 0 ? (
                <div className="text-center py-8">
                  <p className="text-gray-400 dark:text-gray-500 text-sm">{t('supportCase.noActivitiesFound')}</p>
                </div>
              ) : (
                activities.map((activity, index) => (
                  <div 
                    key={index} 
                    className={`bg-gray-50 dark:bg-gray-700 rounded-lg p-4 space-y-3 ${
                      activity.activity_resolution === 1 ? 'bg-green-50 dark:bg-green-800/30' : ''
                    }`}
                  >
                    {/* Activity Type & Start Time */}
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.activityType')}</div>
                        <div className="text-sm text-gray-900 dark:text-white font-medium">{activity.activity_type}</div>
                      </div>
                      <div>
                        <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.startTime')}</div>
                        <div className="text-sm text-gray-900 dark:text-white">{new Date(activity.activity_start_date).toLocaleString('tr-TR')}</div>
                      </div>
                    </div>

                    {/* End Time & Creator */}
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.endTime')}</div>
                        <div className="text-sm text-gray-900 dark:text-white">{new Date(activity.activity_end_date).toLocaleString('tr-TR')}</div>
                      </div>
                      <div>
                        <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.creator')}</div>
                        <div className="text-sm text-gray-900 dark:text-white">{activity.created_by}</div>
                      </div>
                    </div>

                    {/* Activity Detail */}
                    <div>
                      <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">{t('supportCase.activityDetail')}</div>
                      <div className="text-sm text-gray-900 dark:text-white">{activity.activity_message}</div>
                    </div>

                    {/* Actions - Green button with white tick icon */}
                    {activity.support_case_comment === 1 && (
                      <div className="flex justify-end">
                        {activity.activity_resolution !== 1 ? (
                          !activities.some(a => a.activity_resolution === 1) ? (
                            <button
                              onClick={() => handleMarkAsResolve(activity)}
                              className="flex items-center gap-2 px-3 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md text-sm font-medium transition-colors"
                            >
                              <MdCheckCircle size={16} />
                              {t('supportCase.markAsResolved')}
                            </button>
                          ) : (
                            <span className="flex items-center gap-2 px-3 py-2 bg-gray-300 text-gray-500 rounded-md text-sm font-medium cursor-not-allowed">
                              <MdCheckCircle size={16} />
                              {t('supportCase.markAsResolved')}
                            </span>
                          )
                        ) : (
                          <button
                            onClick={() => handleRemoveMark(activity)}
                            className="flex items-center gap-2 px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md text-sm font-medium transition-colors"
                          >
                            <MdCancel size={16} />
                            Remove Mark
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
      {/* Mark As Resolve Popup */}
      {showResolvePopup && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
          <div className="relative mx-auto w-[500px] shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
            {/* Header */}
            <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
              <h3 className="text-lg font-medium">
{t('supportCase.markAsResolved')}
              </h3>
              <button 
                onClick={() => {
                  setShowResolvePopup(false);
                  setSelectedActivityForResolve(null);
                }}
                className="text-white hover:text-gray-200"
              >
                <MdClose size={24} />
              </button>
            </div>
            
                         <div className="p-8 bg-white dark:bg-gray-800">
               <div className="text-center">
                 <p className="text-base text-gray-600 dark:text-gray-400 mb-6">
                   {t('supportCase.confirmMarkAsResolved', { 
                     activityEndDate: selectedActivityForResolve && new Date(selectedActivityForResolve.activity_end_date).toLocaleString(localStorage.getItem('language') === 'en' ? 'en-US' : 'tr-TR')
                   })}
                 </p>
                <div className="flex justify-center gap-4">
                  <button
                    onClick={() => {
                      setShowResolvePopup(false);
                      setSelectedActivityForResolve(null);
                    }}
                    className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500"
                  >
  {t('supportCase.cancel')}
                  </button>
                  <button
                    onClick={confirmMarkAsResolve}
                    className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                    disabled={isResolving}
                  >
                    {isResolving ? t('supportCase.processing') : t('supportCase.yes')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
             )}
       
               {/* Success Popup */}
        {showSuccessPopup && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
            <div className="relative mx-auto w-full max-w-sm shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
              {/* Header */}
              <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
                <h3 className="text-lg font-medium">
{t('supportCase.success')}
                </h3>
                <button 
                  onClick={() => setShowSuccessPopup(false)}
                  className="text-white hover:text-gray-200"
                >
                  <MdClose size={24} />
                </button>
              </div>
              
              <div className="p-8 bg-white dark:bg-gray-800">
                <div className="text-center">
                  <p className="text-base text-gray-600 dark:text-gray-400 mb-6">
                    Destek talebi başarıyla çözüldü olarak işaretlendi.
                  </p>
                  <div className="flex justify-center gap-4">
                    <button
                      onClick={() => setShowSuccessPopup(false)}
                      className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                    >
                      Tamam
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

                 {/* Remove Mark Popup */}
         {showRemoveMarkPopup && (
           <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
             <div className="relative mx-auto w-full max-w-sm shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
               {/* Header */}
               <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
                 <h3 className="text-lg font-medium">
                   Remove Mark
                 </h3>
                 <button 
                   onClick={() => {
                     setShowRemoveMarkPopup(false);
                     setSelectedActivityForRemove(null);
                   }}
                   className="text-white hover:text-gray-200"
                 >
                   <MdClose size={24} />
                 </button>
               </div>
               
               <div className="p-8 bg-white dark:bg-gray-800">
                 <div className="text-center">
                   <p className="text-base text-gray-600 dark:text-gray-400 mb-6">
                     Bu aktiviteden çözüldü işaretini kaldırmak istediğinizden emin misiniz?
                   </p>
                   <div className="flex justify-center gap-4">
                     <button
                       onClick={() => {
                         setShowRemoveMarkPopup(false);
                         setSelectedActivityForRemove(null);
                       }}
                       className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500"
                     >
     {t('supportCase.cancel')}
                     </button>
                     <button
                       onClick={confirmRemoveMark}
                       className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                       disabled={isResolving}
                     >
                       {isResolving ? t('supportCase.processing') : t('supportCase.yes')}
                     </button>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         )}

         {/* Status Success Popup */}
         {showStatusSuccessPopup && (
           <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999] flex items-center justify-center">
             <div className="relative mx-auto w-full max-w-sm shadow-lg rounded-md bg-white dark:bg-gray-800 overflow-hidden">
               {/* Header */}
               <div className="bg-[#272c39] text-white px-6 py-4 flex justify-between items-center">
                 <h3 className="text-lg font-medium">
 {t('supportCase.success')}
                 </h3>
                 <button 
                   onClick={() => setShowStatusSuccessPopup(false)}
                   className="text-white hover:text-gray-200"
                 >
                   <MdClose size={24} />
                 </button>
               </div>
               
               <div className="p-8 bg-white dark:bg-gray-800">
                 <div className="text-center">
                   <p className="text-base text-gray-600 dark:text-gray-400 mb-6">
                     Destek talebi durumu başarıyla güncellendi.
                   </p>
                   <div className="flex justify-center gap-4">
                     <button
                       onClick={() => setShowStatusSuccessPopup(false)}
                       className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                     >
                       Tamam
                     </button>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         )}
     </div>
   );
 };

export default SupportCaseDetailPage; 